import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { StepsModule } from 'primeng/steps';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputNumberModule } from 'primeng/inputnumber';

import { HisSharedModule } from 'hisng';
import { CommonSharedModule } from 'app/fs/res/common/common-shared.module';

import { ResearchInfrastructureUsageTabComponent } from './component/edit/research-infrastructure-usage-tab.component';
import { ResearchInfrastructureDataTabComponent } from './component/edit/research-infrastructure-data-tab.component';
import {
    ResearchInfrastructureEditResearchResultsTabComponent
} from './component/edit/research-infrastructure-edit-research-results-tab.component';
import { ResearchInfrastructureEditFormComponent } from './component/edit/research-infrastructure-edit-form.component';
import { ResearchInfrastructureUsageComponent } from './component/edit/usage/research-infrastructure-usage.component';
import { ResearchInfrastructureAccessSelectComponent } from './component/edit/basic-data/research-infrastructure-access-select.component';
import { ResearchInfrastructureMemberSelectComponent } from './component/edit/basic-data/research-infrastructure-members-select.component';
import {
    ResearchInfrastructureEmploymentsComponent
} from './component/edit/usage/research-infrastructure-employments.component';
import { ResearchInfrastructureSearchFormComponent } from './component/search/research-infrastructure-search-form.component';
import { ResearchInfrastructureSearchResultComponent } from './component/search/research-infrastructure-search-result.component';
import { ResearchInfrastructureBasicDataComponent } from './component/edit/basic-data/research-infrastructure-basic-data.component';
import { ResearchInfrastructureViewDetailsComponent } from './component/view/research-infrastructure-view-details.component';
import { ResearchInfrastructureViewMainDataComponent } from './component/view/details/research-infrastructure-view-main-data.component';
import { ResearchInfrastructureViewVCardComponent } from './component/view/vcard/research-infrastructure-view-vcard.component';
import { ResearchInfrastructureEditUsageNumbersDialogComponent }
    from './component/edit/usage/usage-numbers/research-infrastructure-edit-usage-numbers-dialog.component';
import { ResearchInfrastructureEditEmploymentWizardComponent }
    from './component/edit/usage/employments/research-infrastructure-edit-employment-wizard.component';
import { ResearchInfrastructureSearchPersonEmploymentComponent }
    from './component/edit/usage/employments/research-infrastructure-search-person-employment.component';
import { ResearchInfrastructureEditEmploymentAdditionalDataComponent }
    from './component/edit/usage/employments/research-infrastructure-edit-employment-additional-data.component';
// eslint-disable-next-line max-len
import { ResearchInfrastructureAccesskindPlamComponent } from './component/edit/basic-data/research-infrastructure-accesskind-plam.component';

@NgModule( {
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,

        // primeng
        AutoCompleteModule,
        ConfirmDialogModule,
        CalendarModule,
        DialogModule,
        InputNumberModule,
        OverlayPanelModule,
        PanelModule,
        StepsModule,
        TabViewModule,
        TableModule,

        // HIS
        HisSharedModule,
        CommonSharedModule

    ],

    declarations: [
        ResearchInfrastructureBasicDataComponent,
        ResearchInfrastructureEditFormComponent,
        ResearchInfrastructureDataTabComponent,
        ResearchInfrastructureAccesskindPlamComponent,
        ResearchInfrastructureAccessSelectComponent,
        ResearchInfrastructureMemberSelectComponent,
        ResearchInfrastructureUsageTabComponent,
        ResearchInfrastructureUsageComponent,
        ResearchInfrastructureEmploymentsComponent,
        ResearchInfrastructureSearchFormComponent,
        ResearchInfrastructureSearchResultComponent,
        ResearchInfrastructureEditResearchResultsTabComponent,
        ResearchInfrastructureViewDetailsComponent,
        ResearchInfrastructureViewMainDataComponent,
        ResearchInfrastructureViewVCardComponent,
        ResearchInfrastructureEditUsageNumbersDialogComponent,
        ResearchInfrastructureEditEmploymentWizardComponent,
        ResearchInfrastructureSearchPersonEmploymentComponent,
        ResearchInfrastructureEditEmploymentAdditionalDataComponent,
    ],

    exports: []

} )
export class ResearchInfrastructureSharedModule {
}
